import { MODEL_VERSION } from '@/app/constants';

const IMG2VIDEO_MAX_IMAGE_COUNT: Readonly<Record<string, number>> = {
  [MODEL_VERSION.Q2]: 10,
  [MODEL_VERSION.Q3_HH]: 1,
  // Q4 双图能力尚未开放；开放后只需将这里调整为 2。
  [MODEL_VERSION.Q4]: 1,
};

export const getImg2VideoMaxImageCount = (modelVersion?: string): number => {
  if (!modelVersion) return 2;
  return IMG2VIDEO_MAX_IMAGE_COUNT[modelVersion] ?? 2;
};
